import * as types from '../constants/actionTypes';

export const setPortalSsoCode = (portalSsoCode) => {
  return {
    type: types.SET_PORTAL_SSO_CODE,
    payload: portalSsoCode
  }
}